import React, { useContext, useMemo, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { data_meta } from "../importmetadata";

import { Area1Set, ModeSet } from "../App";
import Csv2kml from "../makekml/csv2kml";

const DEFAULT_AREA = "福岡県糸島市";

/**
 * ✅ 合言葉（どれかに一致すればOK）
 * - ここだけ運用で差し替え
 * - 文字列は完全一致（trim + NFKC 正規化して比較）
 */
const ALLOWED_PASSWORDS = [
  "teacher",
  "teikoku",
  "geograph",
  // "2026spring",
];

/** id から chknum を作る（安全に） */
const calcChknum = (id) => {
  if (!id) return null;
  const parts = String(id).split("_");
  if (parts.length < 2) return null;
  const a = parts[0] ?? "";
  const b = Number(parts[1]);
  if (!Number.isFinite(b)) return null;
  return Number(String(a).length) + b;
};

const canViewTeacherSupport = (chknum) => {
  if (!Number.isFinite(chknum)) return false;
  return chknum % 13 === 3 && chknum % 7 === 3;
};

const normalizePass = (s) => String(s ?? "").trim().normalize("NFKC");

const KmlDownloadButton = ({ r, area }) => {
  return (
    <Csv2kml key={`${r.no}:${area}`} meta={r} area={area}>
      <span className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center cursor-pointer select-none">
        <svg
          className="fill-current w-4 h-4 mr-2"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" />
        </svg>
        <span>KML</span>
      </span>
    </Csv2kml>
  );
};

export const Teachersupport = () => {
  const { area1set, setArea1Set } = useContext(Area1Set);

  // ModeSetの変更で再描画させたいので参照だけする
  useContext(ModeSet);

  const { id } = useParams();

  const chknum = useMemo(() => calcChknum(id), [id]);
  const allowed = useMemo(() => canViewTeacherSupport(chknum), [chknum]);

  // localStorageは初期化時のみ読む
  const [savedArea] = useState(() => localStorage.getItem("area1set"));
  const currentArea = area1set || savedArea || DEFAULT_AREA;

  const handleSubmitArea = (value) => {
    const next = value?.trim();
    if (!next) return;
    localStorage.setItem("area1set", next);
    setArea1Set(next);
  };

  const filteredMetadata = useMemo(
    () => data_meta.filter((r) => r.site === "g"),
    []
  );

  // ✅ 記事一覧（将来増やしやすい）
  const articleList = useMemo(
    () => [
      {
        title:
          "地域課題の発見と解決へ ～学びの力で社会に貢献しようとする中学生の挑戦～",
        author: "船橋市立葛飾中学校 教諭 歌津 文也",
        url: "pdf/地域課題の発見と解決へ.pdf",
      },
      {
        title: "学習上のGIS活用の入門的指導",
        author: "拓殖大学 非常勤講師 池下 誠",
        url: "/pdf/学習上のGIS活用の入門的指導.pdf",
      },
      {
        title:
          "高等学校 地理 探究型学習スタートアップ ～地球観測衛星データの3次元メッシュマップを用いて～",
        author: "品川女子学院 教諭 河合 豊明",
        url: "/pdf/高等学校 地理  探究型学習スタートアップ.pdf",
      },
      {
        title:
          "中学校社会科「地域の在り方」単元の実践 ～JAXAデータをもとに深める、持続可能な社会の実現に向けた考察力～",
        author: "新潟県 上越教育大学附属中学校 教諭 仙田 健一",
        url: "/pdf/中学校社会科「地域の在り方」単元の実践.pdf",
      },
      {
        title:
          "「地域の在り方」単元だからこそ育まれるコンピテンシー、将来を生きる力 ～フィールドワークとICT利活用の複合が加速させる、考察・議論・構想～",
        author: "新潟県 上越教育大学附属中学校 教諭 仙田健一",
        url: "https://www.teikokushoin.co.jp/files/common/%E3%80%8C%E5%9C%B0%E5%9F%9F%E3%81%AE%E5%9C%A8%E3%82%8A%E6%96%B9%E3%80%8D%E5%8D%98%E5%85%83%E3%81%A0%E3%81%8B%E3%82%89%E3%81%93%E3%81%9D%E8%82%B2%E3%81%BE%E3%82%8C%E3%82%8B%E3%82%B3%E3%83%B3%E3%83%94%E3%83%86%E3%83%B3%E3%82%B7%E3%83%BC%E3%80%81%E5%B0%86%E6%9D%A5%E3%82%92%E7%94%9F%E3%81%8D%E3%82%8B%E5%8A%9B%20%EF%BD%9E%E3%83%95%E3%82%A3%E3%83%BC%E3%83%AB%E3%83%89%E3%83%AF%E3%83%BC%E3%82%AF%E3%81%A8%20ICT%20%E5%88%A9%E6%B4%BB%E7%94%A8%E3%81%AE%E8%A4%87%E5%90%88%E3%81%8C%E5%8A%A0%E9%80%9F%E3%81%95%E3%81%9B%E3%82%8B%E3%80%81%E8%80%83%E5%AF%9F%E3%83%BB%E8%AD%B0%E8%AB%96%E3%83%BB%E6%A7%8B%E6%83%B3%EF%BD%9E.pdf",
      },
      {
        title: "ICT利活用で拓く、中山間部校の探究的な学び",
        author: "兵庫県 丹波市立柏原中学校 主幹教諭 高木 聡子",
        url: "https://www.geograph.teikokushoin.co.jp/pdf/ICT利活用で拓く中山間部校の探究的な学び.pdf",
      },
      {
        title: "ジオグラフ活用場面（中学校社会科）",
        author: "(株)帝国書院 研究室",
        url: "pdf/ジオグラフ_活用場面_中学校社会科_20231003.pdf",
      },
    ],
    []
  );

  // ✅ 技術資料（将来増やしやすい）
  const techDocList = useMemo(
    () => [
      {
        title: "はじめてのGISサポート",
        author: "帝国書院",
        url: "https://www.teikokushoin.co.jp/files/product1/08koukou/08%E3%81%AF%E3%81%98%E3%82%81%E3%81%A6%E3%81%AEGIS%E3%82%B5%E3%83%9D%E3%83%BC%E3%83%88.pdf",
      },
      {
        title: "ジオグラフができるまで（高校地理教育における都市構造可視化の活用についての研究）",
        author: "石井儀光 他",
        url: "https://www.cpij.or.jp/com/ac/reports/20_146.pdf",
      },
      // {
      //   title: "活用風景の動画（約3分） ※音量にご注意ください",
      //   author: "都市構造可視化推進機構",
      //   url: "https://youtu.be/kfQ8Zn52lHo?si=BnUn32kgyc2JUGPP",
      // },
      {
        title: "JAXAデータの紹介（サテナビ）",
        author: "JAXA",
        url: "https://www.satnavi.jaxa.jp/ja/satellite-knowledge/case-study/geograph/index.html",
      },
      {
        title: "オーダーメイド研修のご案内",
        author: "都市構造可視化推進機構",
        url: "https://kashika.or.jp/kensyu-3/",
      },
      {
        title: "まちづくりの現場での活用事例（i-都市交流会議2020発表資料集）",
        author: "i都市交流会議事務局",
        url: "https://www.cpij.or.jp/com/ac/reports/20_146.pdf",
      },
    ],
    []
  );

  const [areaEditOpen, setAreaEditOpen] = useState(false);
  const [areaDraft, setAreaDraft] = useState(currentArea);

  useEffect(() => {
    setAreaDraft(currentArea);
  }, [currentArea]);

  // =========================
  // ✅ 合言葉認証（タブを閉じたら消える）
  // =========================
  const authKey = useMemo(() => `teachersupport_auth:${id ?? ""}`, [id]);

  const [authed, setAuthed] = useState(() => {
    // allowed=false のときは意味がないが、初期化は軽いのでOK
    return sessionStorage.getItem(authKey) === "1";
  });

  // id が変わったら（URL変わったら）セッション状態を読み直す
  useEffect(() => {
    setAuthed(sessionStorage.getItem(authKey) === "1");
  }, [authKey]);

  const [passOpen, setPassOpen] = useState(false);
  const [passDraft, setPassDraft] = useState("");
  const [passError, setPassError] = useState("");

  useEffect(() => {
    // IDが正しいのに未認証ならパス入力へ
    if (allowed && !authed) setPassOpen(true);
    else setPassOpen(false);
  }, [allowed, authed]);

  const submitPassword = () => {
    const v = normalizePass(passDraft);
    const ok = ALLOWED_PASSWORDS.map(normalizePass).includes(v);

    if (!ok) {
      setPassError("合言葉が一致しません。もう一度お試しください。");
      return;
    }

    sessionStorage.setItem(authKey, "1");
    setAuthed(true);
    setPassError("");
    setPassDraft("");
    setPassOpen(false);
  };

  const openMapInNewTab = (no) => {
    const url = `/map/1/${encodeURIComponent(String(no))}/${encodeURIComponent(
      String(currentArea)
    )}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  // ✅ 記事を新しいタブで開く（行クリック用）
  const openArticleInNewTab = (url) => {
    if (!url) return;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const ClickableCell = ({ no, children, className = "" }) => {
    return (
      <div
        className={[
          "px-4 py-1 w-full h-full cursor-pointer select-none group-hover:bg-gray-100",
          className,
        ].join(" ")}
        onClick={() => openMapInNewTab(no)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            openMapInNewTab(no);
          }
        }}
        role="link"
        tabIndex={0}
        title="新しいタブで開く"
      >
        {children}
      </div>
    );
  };

  // ✅ 記事一覧の行クリック（table row全体）
  const ArticleRow = ({ a }) => {
    const onOpen = () => openArticleInNewTab(a.url);

    return (
      <tr
        className="group hover:bg-gray-50 cursor-pointer"
        title="新しいタブで開く"
        onClick={onOpen}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onOpen();
          }
        }}
        role="link"
        tabIndex={0}
      >
        <td className="px-4 py-2 border border-gray-200">
          <span className="group-hover:underline">{a.title}</span>
        </td>
        <td className="px-4 py-2 border border-gray-200 text-gray-600">
          {a.author}
        </td>
      </tr>
    );
  };

  const StopOpenDot = ({ children }) => {
    // ●のクリック/キー操作だけは「新タブを開く」を阻止
    return (
      <span
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") e.stopPropagation();
        }}
      >
        {children}
      </span>
    );
  };

  // =========================
  // ① IDが間違っている場合：今のまま
  // =========================
  if (!allowed) {
    return (
      <div className="absolute z-30 w-full min-h-screen bg-white text-gray-900">
        <header className="border-b border-gray-200">
          <div className="max-w-3xl mx-auto px-6 py-10">
            <h1 className="text-2xl font-semibold tracking-tight">
              教職員向けサポートページ
            </h1>
            <p className="mt-3 text-sm text-gray-700 leading-relaxed">
              ジオグラフへようこそ。ここは教職員用サポートページです。
              <br />
              ご利用には個人ごとのログインIDが必要です。お近くの帝国書院営業担当までお申し付けください。
            </p>
          </div>
        </header>
      </div>
    );
  }

  // =========================
  // ② IDが合っている場合：パスワード画面（未認証）
  // =========================
  if (passOpen && !authed) {
    return (
      <div className="absolute z-30 w-full min-h-screen bg-white text-gray-900">
        <header className="border-b border-gray-200">
          <div className="max-w-3xl mx-auto px-6 py-10">
            <h1 className="text-2xl font-semibold tracking-tight">
              教職員向けサポートページ
            </h1>
            <p className="mt-3 text-sm text-gray-700 leading-relaxed">
              このページは教職員向けです。合言葉を入力してください。
              <br />
              ※ 合言葉はタブを閉じると解除されます。
            </p>

            <div className="mt-6 border border-gray-200 rounded-md p-4 bg-gray-50">
              <label className="block text-sm text-gray-700">
                パスワード
              </label>
              <input
                type="password"
                value={passDraft}
                onChange={(e) => {
                  setPassDraft(e.target.value);
                  if (passError) setPassError("");
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") submitPassword();
                }}
                className="mt-2 w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-300 bg-white"
                placeholder="合言葉を入力"
                autoFocus
              />

              {passError && (
                <div className="mt-2 text-sm text-red-600">{passError}</div>
              )}

              <div className="mt-4 flex items-center gap-2">
                <button
                  type="button"
                  className="px-4 py-2 text-sm rounded-md border border-gray-300 bg-white hover:bg-gray-50"
                  onClick={submitPassword}
                >
                  入室
                </button>
                <div className="text-xs text-gray-500">
                  Enter でも入室できます
                </div>
              </div>
            </div>

            <div className="mt-4 text-xs text-gray-500">
              合言葉が不明な場合は、帝国書院の営業担当までお問い合わせください。
            </div>
          </div>
        </header>
      </div>
    );
  }

  // =========================
  // ③ 認証OK：本編
  // =========================
  return (
    <div className="absolute z-30 w-full min-h-screen bg-white text-gray-900">
      <header className="border-b border-gray-200">
        <div className="max-w-5xl mx-auto px-6 py-6">
          <div className="flex items-start justify-between gap-6">
            <div>
              <h1 className="text-2xl font-semibold tracking-tight">
                教職員向けサポートページ
              </h1>
              <p className="mt-2 text-sm text-gray-600 leading-relaxed">
                本URLは個人ごとに発行しておりますので、共有はお控えください。
                <br />
                追加発行については、帝国書院営業職員までご遠慮なくお知らせください。
              </p>
            </div>

            <div className="text-xs text-gray-500 leading-relaxed text-right">
              <div className="font-medium text-gray-600">サポート</div>
              <div>教材・授業支援コンテンツ</div>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-6">
        {/* ================= 記事一覧（行クリックで開く） ================= */}
        <section className="mb-8">
          <div className="flex items-end justify-between gap-4">
            <h2 className="text-base font-semibold">実践事例</h2>
            <div className="text-xs text-gray-500">件数：{articleList.length}</div>
          </div>

          <div className="mt-3">
            <table className="min-w-full border border-gray-300 text-sm leading-tight">
              <thead>
                <tr className="bg-gray-50">
                  <th className="px-4 py-2 border border-gray-300 text-left font-semibold">
                    タイトル
                  </th>
                  <th className="px-4 py-2 border border-gray-300 text-left font-semibold">
                    著者
                  </th>
                </tr>
              </thead>

              <tbody>
                {articleList.map((a, i) => (
                  <ArticleRow key={`article:${i}`} a={a} />
                ))}
              </tbody>
            </table>

            <div className="mt-2 text-xs text-gray-500">
              ヒント：行をクリックすると新しいタブで開きます。
            </div>
          </div>
        </section>

        {/* ================= 技術資料（行クリックで開く） ================= */}
        <section className="mb-8">
          <div className="flex items-end justify-between gap-4">
            <h2 className="text-base font-semibold">技術資料</h2>
            <div className="text-xs text-gray-500">件数：{techDocList.length}</div>
          </div>

          <div className="mt-3">
            <table className="min-w-full border border-gray-300 text-sm leading-tight">
              <thead>
                <tr className="bg-gray-50">
                  <th className="px-4 py-2 border border-gray-300 text-left font-semibold">
                    タイトル
                  </th>
                  <th className="px-4 py-2 border border-gray-300 text-left font-semibold">
                    著者
                  </th>
                </tr>
              </thead>

              <tbody>
                {techDocList.map((a, i) => (
                  <ArticleRow key={`techdoc:${i}`} a={a} />
                ))}
              </tbody>
            </table>

            <div className="mt-2 text-xs text-gray-500">
              ヒント：行をクリックすると新しいタブで開きます。
            </div>
          </div>
        </section>

        <section className="mt-6">
          <div className="flex items-end justify-between gap-4">
            <h2 className="text-base font-semibold">掲載テーマ一覧</h2>
            <div className="text-xs text-gray-500">
              件数：{filteredMetadata.length}
            </div>
          </div>

        <section className="border border-gray-200 rounded-md px-4 py-3">
          <div className="flex items-center justify-between gap-3 flex-wrap">
            <div className="text-sm">
              <span className="text-gray-500">現在の対象エリア：</span>
              <span className="font-semibold text-gray-900">{currentArea}</span>
            </div>

            <div className="flex items-center gap-2">
              <button
                type="button"
                className="px-3 py-1 text-xs rounded-md border border-gray-300 bg-white hover:bg-gray-50"
                onClick={() => setAreaEditOpen((v) => !v)}
              >
                {areaEditOpen ? "閉じる" : "変更"}
              </button>

              <div className="text-xs text-gray-500">
                KML出力対象の市町村になります
              </div>
            </div>
          </div>

          {areaEditOpen && (
            <div className="mt-3 pt-3 border-t border-gray-200">
              <div className="flex items-center gap-2 flex-wrap">
                <input
                  type="text"
                  value={areaDraft}
                  onChange={(e) => setAreaDraft(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      const v = e.currentTarget.value?.trim();
                      if (v) {
                        handleSubmitArea(v);
                        setAreaEditOpen(false);
                      }
                    }
                    if (e.key === "Escape") setAreaEditOpen(false);
                  }}
                  placeholder="例）福岡県糸島市"
                  className="w-full sm:w-[360px] px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-300"
                />
                <button
                  type="button"
                  className="px-4 py-2 text-sm rounded-md border border-gray-300 bg-white hover:bg-gray-50"
                  onClick={() => {
                    const v = areaDraft?.trim();
                    if (v) {
                      handleSubmitArea(v);
                      setAreaEditOpen(false);
                    }
                  }}
                >
                  保存
                </button>
              </div>

              <div className="mt-2 text-xs text-gray-500 leading-relaxed">
                Enterで保存 / Escで閉じる。表の「NO / テーマ」をクリックすると新しいタブで開きます。
              </div>
            </div>
          )}
        </section>

          <div className="mt-3">
            <table className="min-w-full border border-gray-300 text-sm leading-tight">
              <thead>
                <tr className="bg-gray-50">
                  <th className="px-4 py-2 border border-gray-300 text-left font-semibold">
                    NO
                  </th>
                  <th className="px-4 py-2 border border-gray-300 text-left font-semibold">
                    テーマ
                  </th>
                  <th className="px-4 py-2 border border-gray-300 text-left font-semibold">
                    初級
                  </th>
                  <th className="px-4 py-2 border border-gray-300 text-left font-semibold">
                    高さ
                  </th>
                  <th className="px-4 py-2 border border-gray-300 text-left font-semibold">
                    色
                  </th>
                  <th className="px-4 py-2 border border-gray-300 text-left font-semibold">
                    年次
                  </th>
                  <th className="px-4 py-2 border border-gray-300 text-left font-semibold">
                    色
                  </th>
                  <th className="px-4 py-2 border border-gray-300 text-left font-semibold">
                    KML
                  </th>
                  <th className="px-4 py-2 border border-gray-300 text-left font-semibold">
                    典型都市
                  </th>
                </tr>
              </thead>

              <tbody>
                {filteredMetadata.map((r) => (
                  <tr
                    key={String(r.no)}
                    className="group hover:bg-gray-50"
                    title="新しいタブで開く（NO〜年次）"
                  >
                    <td className="border border-gray-200 p-0">
                      <ClickableCell no={r.no}>
                        <span className="group-hover:underline">{r.no}</span>
                      </ClickableCell>
                    </td>

                    <td className="border border-gray-200 p-0">
                      <ClickableCell no={r.no}>
                        <span className="group-hover:underline">{r.title}</span>
                      </ClickableCell>
                    </td>

                    <td className="border border-gray-200 p-0 text-center text-gray-600">
                      <ClickableCell no={r.no}>
                        {r.hanrei_height_name === r.hanrei_color_name && (
                          <div className="relative group inline-block">
                            <StopOpenDot>
                              <span className="text-gray-500 text-xs cursor-help">
                                ●
                              </span>
                            </StopOpenDot>

                            <div className="absolute bottom-full mb-1 left-1/2 -translate-x-1/2 whitespace-nowrap bg-gray-800 text-white text-[10px] px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition pointer-events-none">
                              高さと色が同一指標
                            </div>
                          </div>
                        )}
                      </ClickableCell>
                    </td>

                    <td className="border border-gray-200 p-0 text-gray-600">
                      <ClickableCell no={r.no}>
                        {r.hanrei_height_name}
                      </ClickableCell>
                    </td>

                    <td className="border border-gray-200 p-0">
                      <ClickableCell no={r.no}>{r.hanrei_color_name}</ClickableCell>
                    </td>

                    <td className="border border-gray-200 p-0">
                      <ClickableCell no={r.no}>{r.year_display}</ClickableCell>
                    </td>

                    <td className="border border-gray-200 p-0">
                      <ClickableCell no={r.no}>
                        <div className="flex items-center gap-1">
                          {[
                            r.hanrei1_color,
                            r.hanrei2_color,
                            r.hanrei3_color,
                            r.hanrei4_color,
                            r.hanrei5_color,
                          ]
                            .map((v) => (typeof v === "string" ? v.trim() : ""))
                            .filter((v) => v)
                            .map((color, i) => (
                              <span
                                key={`${r.no}:hanrei-color:${i}:${color}`}
                                className="inline-block w-4 h-4 rounded-sm border border-gray-300"
                                style={{ backgroundColor: color }}
                                title={color}
                              />
                            ))}
                        </div>
                      </ClickableCell>
                    </td>

                    <td className="px-4 py-1 border border-gray-200 text-gray-400 text-sm">
                      {Number(r.kml_ok) !== 0 ? (
                        <KmlDownloadButton r={r} area={currentArea} />
                      ) : (
                        "―"
                      )}
                    </td>

                    <td className="px-4 py-1 border border-gray-200">
                      {r.tenkei_city}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="mt-2 text-xs text-gray-500">
              ヒント：行（NO〜年次）をクリックすると新しいタブで開きます。
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};
